import React, { useState } from 'react';
import store from '@apply/adminStore';
import ActionSheet from 'devextreme-react/action-sheet';
import { InformModal } from '../../../common/SharedComponents';
import { getApplicationActions, onApplicationActionItem } from '../ApplicationFunctions';

export const ApplActionsButton = ({ data, isPropertyLevel = false, parentElementId }) => {
    const { dispatch } = store;

    const [actionData, set_actionData] = useState({
        visible: false,
        target: null,
        items: [],
    });
    const [informModalOpen, set_informModalOpen] = useState(false);

    const onActionClicked = (event, application) => {
        event.preventDefault();
        event.stopPropagation();

        const actions = getApplicationActions(application, isPropertyLevel);

        if (actions.length === 0) {
            set_informModalOpen(true);
            return;
        }

        var data = {
            items: actions,
            target: `#${event.target.id}`,
            visible: true,
        };
        set_actionData(data);
    };

    const actionsDisabled = (application) => {
        const actions = getApplicationActions(application, isPropertyLevel);
        return actions.length === 0;
    };

    const onActionItemClick = (e) => {
        set_actionData({ ...actionData, visible: false });
        onApplicationActionItem(dispatch, e.itemData.id, e.itemData.applicationId, e.itemData.propertyId);
    };

    const onActionSheetVisibleChange = (isVisible) => {
        if (isVisible !== actionData?.visible) {
            set_actionData({ ...actionData, visible: isVisible });
        }
    };

    if (!data) {
        return null;
    }

    return (
        <>
            <button
                id={`action_${parentElementId ?? ''}_${data.id}_${data.propertyId}`}
                className='gridButton'
                title='Click to see options'
                onClick={(event) => onActionClicked(event, data)}
                disabled={actionsDisabled(data)}
            >
                ...
            </button>
            <ActionSheet
                title='Choose action'
                usePopover={true}
                visible={actionData.visible}
                target={actionData.target}
                items={actionData.items}
                onItemClick={onActionItemClick}
                onVisibleChange={onActionSheetVisibleChange}
                showTitle={false}
            />
            <InformModal
                isOpen={informModalOpen}
                text={'No actions available'}
                confirmCallback={() => set_informModalOpen(false)}
            />
        </>
    );
};
